import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid2';
import InputItem from './inputItem';
import React from 'react';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { removeDoubleNegative } from '../../utils/helpers';

const useStyles = makeStyles(() => ({
  label: {
    textTransform: 'none',
  },
  defaultSpan: { float: 'right', cursor: 'pointer', textDecoration: 'underline' },
}));

export default ({
  items = [],
  setInput,
  values,
  onSetDefaultValues,
  tab = false,
  showDivider = true,
  alignRight = false,
  originCashflow = false,
}) => {
  const classes = useStyles();

  return items.map((item, idx) => (
    <Grid
      key={`input-list-item-${item.label}-${idx}`}
      container
      direction="column"
      style={{ padding: '5px 0' }}
    >
      <Typography className={classes.label} variant="overline">
        {item.label}
        {item.setDefault && (
          <span className={classes.defaultSpan} onClick={() => onSetDefaultValues(item)}>
            {item.setDefault.label}
          </span>
        )}
      </Typography>
      {showDivider && <Divider />}
      <Grid
        style={{ paddingTop: '5px', paddingBottom: '10px' }}
        container
        direction="row"
        sx={{
          justifyContent: 'space-around',
          alignItems: 'center',
        }}
      >
        {item.icon}
        {item.isMinMax ? (
          <>
            <InputItem
              id={item.id}
              inputLabel={item.min?.inputLabel}
              isMinMax
              onChange={(e) =>
                setInput(
                  e.target.value.match(/^(\d|\.|-)+$/) ? removeDoubleNegative(e.target.value) : '',
                  item.min?.key,
                )
              }
              value={values[item.min?.key]}
              tab={tab}
              alignRight={alignRight}
              originCashflow={originCashflow}
            />
            <InputItem
              id={item.id}
              inputLabel={item.max?.inputLabel}
              isMinMax
              onChange={(e) =>
                setInput(
                  e.target.value.match(/^(\d|\.|-)+$/) ? removeDoubleNegative(e.target.value) : '',
                  item.max?.key,
                )
              }
              value={values[item.max?.key]}
              tab={tab}
              alignRight={alignRight}
              originCashflow={originCashflow}
            />
          </>
        ) : (
          <InputItem
            id={item.id}
            inputLabel={item.inputLabel}
            required={item.required}
            onChange={(e) =>
              setInput(
                e.target.value.match(/^(\d|\.|-)+$/) ? removeDoubleNegative(e.target.value) : '',
                item.key,
              )
            }
            value={values[item.key]}
            tab={tab}
            alignRight={alignRight}
            originCashflow={originCashflow}
          />
        )}
      </Grid>
    </Grid>
  ));
};
